<script lang="ts">
  import { BlogSingleData } from '../../../../Data/Miscellaneous/Blog';
  import Card from "../../../Core/Card.svelte";
  import BlogComment from "./BlogComment.svelte";
</script>
<Card cardProps="comment-box">
    <div slot="contentbody">
        <h4>{'Comment'}</h4>
        <ul>
            {#each BlogSingleData as elem}
                <li>
                    {#if elem.id !== 2}
                        <BlogComment {elem} />
                    {:else}
                        <ul>
                            <li>
                                <BlogComment {elem} />
                            </li>
                        </ul>
                    {/if}
                </li>
            {/each}
        </ul>
    </div>
</Card>